@if (blockMeasureYourself.title) {
<p class="title">{{ blockMeasureYourself.title }}</p>
} @if (blockMeasureYourself.steps && blockMeasureYourself.steps.length > 1) {
<ol>
    @for (step of blockMeasureYourself.steps; track step) {
    <li
        [attr.custom-decoration]="step.customDecoration"
        class="step"
        [ngClass]="{
            custom: step.customDecoration && !step.title,
            simple: !step.customDecoration,
            'custom-title': step.customDecoration && step.title
        }">
        <div class="step-title-content">
            @if (step.title) {
            <p class="step-title">{{ step.title }}</p>
            }
            <p class="step-content">{{ step.content }}</p>
        </div>
    </li>
    }
</ol>
} @if (blockMeasureYourself.steps && blockMeasureYourself.steps.length === 1) { @if
(blockMeasureYourself.steps[0].title; as title) {
<p class="step-title">{{ title }}</p>
}
<p class="step-content">{{ blockMeasureYourself.steps[0].content }}</p>
}
